import _isEmpty from 'lodash/isEmpty';
import _delay from 'lodash/delay';
import { isEqual, isBefore } from 'date-fns';
import { getSessionExpiryTime, convertMinutesToMilliseconds, calculateSessionExpiryTime } from 'common/sessionTimeout';
import { STRINGS } from 'config';
import { VALIDATION_MESSAGES } from 'common/validationMessages';
import { apiGet } from 'common/apiRequests';

let session;
let sessionWarning;
export const restartSession = () => dispatch => {
  clearTimeout(session);
  clearTimeout(sessionWarning);
  dispatch({ type: STRINGS.SESSION_REDUCER.RESTART_SESSION });
};

export const openSessionExpiryWarning = () => ({ type: STRINGS.SESSION_REDUCER.OPEN_SESSION_EXPIRY_WARNING });

export const closeSessionExpiryWarning = () => ({ type: STRINGS.SESSION_REDUCER.CLOSE_SESSION_EXPIRY_WARNING });

export const closeDemoNotice = () => ({ type: STRINGS.SESSION_REDUCER.CLOSE_DEMO_NOTICE });

export const setSessionExpiryValidation = product => dispatch => {
  const journeyType = product === STRINGS.PRODUCT.E_SPECIALIST ? 'questionnaire' : 'consultation';
  const { getTemplatedValidation } = VALIDATION_MESSAGES;
  dispatch({
    type: STRINGS.SESSION_REDUCER.SET_SESSION_EXPIRY_VALIDATION,
    payload: getTemplatedValidation(VALIDATION_MESSAGES.SESSION_TIMEOUT, { journeyType: journeyType }),
  });
};

export const handleSessionExpiry = () => (dispatch, getState) => {
  const { product, questionIndex } = getState().consultationReducer;
  dispatch(restartSession());
  dispatch(setSessionExpiryValidation(product));
  window.history.go(-questionIndex);
};
export const setSessionTimeout = () => (dispatch, getState) => {
  const { product } = getState().consultationReducer;
  dispatch({
    type: STRINGS.SESSION_REDUCER.RESET_SESSION_TIMEOUT,
    payload: getSessionExpiryTime(),
  });
  clearTimeout(session);
  clearTimeout(sessionWarning);
  dispatch(closeSessionExpiryWarning());
  // Only show session expiry modal and auto restart session in Primary Care. The webapp handles it for eTriage
  if (product === STRINGS.PRODUCT.PRIMARY_CARE || product === STRINGS.PRODUCT.E_SPECIALIST) {
    session = setTimeout(() => dispatch(handleSessionExpiry()), convertMinutesToMilliseconds(STRINGS.SESSION_TIMEOUT.IN_MINUTES));
    sessionWarning = setTimeout(
      () => dispatch(openSessionExpiryWarning()),
      convertMinutesToMilliseconds((STRINGS.SESSION_TIMEOUT.IN_MINUTES * 0.83)),
    ); // 30 minutes * 0.83 gives roughly 25 minutes.
  }
};

export const evaluateSessionTimeout = () => (dispatch, getState) => {
  const { sessionExpiryTime, product } = getState().consultationReducer;
  if (_isEmpty(sessionExpiryTime)) {
    return null;
  }

  clearTimeout(session);
  clearTimeout(sessionWarning);

  const isSessionExpired = isEqual(new Date(sessionExpiryTime), new Date()) || isBefore(new Date(sessionExpiryTime), new Date());
  if (isSessionExpired) {
    return null;
  }

  const { millisecondsToSessionWarning, millisecondsToSessionExpiry } = calculateSessionExpiryTime(sessionExpiryTime);
  if (millisecondsToSessionWarning > 0) {
    dispatch(closeSessionExpiryWarning());
  }
  // Only show session expiry modal and auto restart session in Primary Care. The webapp handles it for eTriage
  if (product === STRINGS.PRODUCT.PRIMARY_CARE || product === STRINGS.PRODUCT.E_SPECIALIST) {
    session = setTimeout(() => dispatch(handleSessionExpiry()), millisecondsToSessionExpiry);
    sessionWarning = setTimeout(() => dispatch(openSessionExpiryWarning()), millisecondsToSessionWarning);
    dispatch({ type: STRINGS.SESSION_REDUCER.RE_RESET_SESSION_TIMEOUT });
  }
  return null;
};

export const clearSessionTimeout = () => dispatch => {
  clearTimeout(session);
  clearTimeout(sessionWarning);
  dispatch({ type: STRINGS.SESSION_REDUCER.CLEAR_SESSION_TIMEOUT });
};

// Back button handling
export const openLeavePageWarning = () => ({ type: STRINGS.SESSION_REDUCER.OPEN_LEAVE_PAGE_WARNING });

export const closeLeavePageWarning = () => ({ type: STRINGS.SESSION_REDUCER.CLOSE_LEAVE_PAGE_WARNING });

export const confirmContinueWithConsult = () => dispatch => {
  dispatch({ type: STRINGS.SESSION_REDUCER.CLOSE_LEAVE_PAGE_WARNING });
  window.history.forward();
};

export const confirmLeavingPage = () => dispatch => {
  dispatch({ type: STRINGS.SESSION_REDUCER.CONFIRM_LEAVE_PAGE });
  dispatch(restartSession());
};

export const extendSession = () => (dispatch, getState) => {
  const consultationState = getState().consultationReducer;
  dispatch({ type: STRINGS.SESSION_REDUCER.EXTEND_SESSION_REQUEST });
  return apiGet(`/session/reset/${consultationState.sessionId}`, consultationState.practice.practiceId)
    .retry(3, error => {
      if (error) {
        dispatch({ type: `${STRINGS.SESSION_REDUCER.EXTEND_SESSION_REQUEST}_RETRY` });
      }
    })
    .then(response => {
      dispatch({ type: STRINGS.SESSION_REDUCER.EXTEND_SESSION_SUCCESS, payload: response });
      dispatch(setSessionTimeout());
    })
    .catch(error => dispatch({ type: STRINGS.SESSION_REDUCER.EXTEND_SESSION_ERROR, payload: error }));
};

export const setInternetReconnectedValidation = () => ({ type: STRINGS.SESSION_REDUCER.SET_CONNECTIVITY_MESSAGE, payload: VALIDATION_MESSAGES.CONNECTIVITY.RECONNECTED });

export const clearValidationMessage = () => ({ type: STRINGS.SESSION_REDUCER.CLEAR_VALIDATION_MESSAGE });

export const confirmCancelProgress = () => dispatch => {
  dispatch({ type: STRINGS.SESSION_REDUCER.CANCEL_PROGRESS });
};

export const cancelProgress = () => {
  _delay(() => {
    sessionStorage.setItem('state', '');
    window.open('/killsession', '_self');
  }, 500);
};
export const closeCancelPageWarning = () => ({ type: STRINGS.SESSION_REDUCER.CLOSE_CANCEL_PROGRESS_WARNING });

export const backToTreatmentCategoryListing = () => dispatch => {
  dispatch(restartSession());
  window.location.assign(window.location.href);
};
